import React from 'react'
import { Rating } from '../../Simple/'
import { BiChevronRight } from 'react-icons/bi'
import { FaAngleRight } from 'react-icons/fa6'
import { AuthContext } from '../../../contexts/AuthContext'
import { BsStarFill } from 'react-icons/bs'
import { Services } from '../../../services'
import { semFoto, starAnimated } from '../../../assets/'
import { isSuperAvaliado } from '../../../utils'
import Lottie from 'lottie-react'

import './stylesCE.css'

export default function CompEmpresa({ empresa, onClick }) {
  const { sttAuthCtx } = React.useContext(AuthContext)
  /* Regra de negócio, se a empresa for privada:
      - Preciso verificar se tem um usuário logado!
      - Se tiver, preciso verificar se o usuário tem acesso a empresa!
      - Se não tiver, ao clicar na empresa, precisa solicitar acesso!
      - Se tiver acesso, ao clicar na empresa, precisa ir para a página da empresa!
  */

  if (sttAuthCtx.isMobile) {
    return (
      <button className='btt-contain-comp-empresa' onClick={onClick}>
        <img
          className='img-comp-empresa'
          alt={empresa.nome}
          src={`${empresa.urlFoto}${empresa.foto}`}
          onError={e => {
            e.target.onerror = null // prevents looping
            e.target.src = semFoto // sets default image
          }}
        />
        <div className='contain-infos-comp-empresa'>
          <div className='contain-title-super-avaliado'>
            <h2 className='title-cmp-empresa'>{empresa.nome}</h2>
            {isSuperAvaliado(empresa) && (
              <Lottie animationData={starAnimated} loop={false} style={{ width: '20px', height: '20px', marginLeft: '5px' }} />
            )}
          </div>
          <div className='tw-flex tw-flex-row'>
            <Rating score={empresa.mediaAvaliacoes} avs={empresa.quantidadeAvaliacoes} />
          </div>
          <p className='text-label-cmp-empresa'>{empresa.descricao !== null ? Services.TruncateString(empresa.descricao, 45) : ''}</p>
        </div>
        <div className='tw-h-full tw-flex tw-justify-center tw-items-center'>
          <FaAngleRight className='icon-select-empresa' />
        </div>
      </button>
    )
  } else {
    return (
      <button className='btt-contain-comp-empresa' onClick={onClick}>
        <div className='contain-comp-empresa-img-infos'>
          <div className='contain-comp-empresa-img'>
            <img
              src={`${empresa.urlFoto}${empresa.foto}`}
              alt={empresa.nome}
              onError={e => {
                e.target.onerror = null // prevents looping
                e.target.src = semFoto // sets default image
              }}
            />
          </div>
          <div className='contain-comp-empresas-img-infos-contain'>
            <h3 className='title-img-infos tw-flex tw-flex-row'>
              {empresa.nome}
              {/* {empresa.quadras.length > 0 && (
                <b style={{ color: '#DA5A34' }}>{` | ${empresa.quadras.length} quadra${empresa.quadras.length > 1 ? 's' : ''}`}</b>
              )} */}
              {isSuperAvaliado(empresa) && (
                <Lottie animationData={starAnimated} loop={false} style={{ width: '20px', height: '20px', marginLeft: '5px', marginTop: '2px' }} />
              )}
            </h3>
            {empresa.visibilidade === 'PRIVADO' && <h4 className='sub-title-empresa-pri'>Centro esportivo privado</h4>}
            <h4 className='sub-title-empresa-desc'>
              {empresa.descricao?.length > 0 ? Services.TruncateString(empresa.descricao, empresa.mediaAvaliacoes > 0 ? 80 : 120) : ''}
            </h4>
            {empresa.mediaAvaliacoes !== 0 && (
              <div className='contain-comp-empresa-avaliacoes'>
                <BsStarFill size={20} color='#FFD700' />
                <h2>
                  {empresa.mediaAvaliacoes.toFixed(1).toString().replace('.', ',') +
                    ` (${empresa.quantidadeAvaliacoes} ${empresa.quantidadeAvaliacoes > 1 ? 'avaliações)' : 'avaliação)'}`}{' '}
                </h2>
              </div>
            )}
          </div>
        </div>
        <BiChevronRight className='btt-icon-empresa-right' size={30} style={{ minHeight: '30px', minWidth: '30px' }} />
      </button>
    )
  }
}
